export default "__VITE_ASSET__C7e5Dk3T__"